// extracted by mini-css-extract-plugin
module.exports = {"bar":"_5DieJi1i","description":"_5D34m2el","list":"_5DZ-bvJc","team-average":"_5DSmYW3J"};